<div class="d-none d-md-block">
  <!-- DESKTOP VIEW -->
  <div class="container-fluid">
    <!-- Page Header -->
    <div class="welcome-section mb-4 fade-in">
      <div *ngIf="!singleTabView; else singleTabViewHeader">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h2 class="fw-bold">System Administration</h2>
            <p class="welcome-text">Manage system users, roles, and categories</p>
          </div>
          <div class="text-end">
            <small class="text-muted d-block">Current User:</small>
            <h6 class="mb-0">{{fullName}}</h6>
            <small class="text-muted d-block">{{tenantName}}</small>
          </div>
        </div>
      </div>

      <ng-template #singleTabViewHeader>
          <div class="d-flex justify-content-between align-items-center">
              <div>
                  <h2 *ngIf="isSupplierView" class="fw-bold">Manage Suppliers</h2>
                  <p *ngIf="isSupplierView" class="welcome-text">Add or update suppliers for your business.</p>
                  <h2 *ngIf="isRoleView" class="fw-bold">Manage Roles</h2>
                  <p *ngIf="isRoleView" class="welcome-text">Add or update roles for your business.</p>
              </div>
              <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
                  <i class="bi bi-arrow-left me-1"></i> Back
              </button>
          </div>
      </ng-template>
    </div>

    <!-- Main Content -->
    <div class="card shadow-sm">
    <!-- Tab Navigation -->
    <div class="card-header bg-white border-bottom-0 pt-3 d-none d-md-block">
      <ul class="nav nav-tabs card-header-tabs" id="configTabs" role="tablist">
        <li  class="nav-item" role="presentation" *ngIf="accountType !== 'calculator' && !singleTabView && userRole === 'Admin User'">
          <button class="nav-link" [class.active]="activeTab === 'users'" (click)="changeTab('users')" id="users-tab" data-bs-toggle="tab" data-bs-target="#users-pane" type="button" role="tab" aria-controls="users-pane" [attr.aria-selected]="activeTab === 'users'">
            <i class="bi bi-people-fill me-2"></i>Users

          </button>
        </li>
        <li class="nav-item" role="presentation" *ngIf="accountType !== 'calculator' && (!singleTabView && userRole === 'Admin User' || isRoleView)">
          <button class="nav-link" [class.active]="activeTab === 'roles'" (click)="changeTab('roles')" id="roles-tab" data-bs-toggle="tab" data-bs-target="#roles-pane" type="button" role="tab" aria-controls="roles-pane" [attr.aria-selected]="activeTab === 'roles'">
            <i class="bi bi-person-gear me-2"></i>Roles

          </button>
        </li>
        <li class="nav-item" role="presentation" *ngIf="accountType !== 'calculator' && !singleTabView">
          <button class="nav-link" [class.active]="activeTab === 'categories'" (click)="changeTab('categories')" id="categories-tab" data-bs-toggle="tab" data-bs-target="#categories-pane" type="button" role="tab" aria-controls="categories-pane" [attr.aria-selected]="activeTab === 'categories'">
            <i class="bi bi-tags-fill me-2"></i>Categories
          </button>
        </li>
        <li class="nav-item" role="presentation" *ngIf="accountType !== 'calculator' && (!singleTabView || isSupplierView)">
          <button class="nav-link" [class.active]="activeTab === 'suppliers'" (click)="changeTab('suppliers')" id="suppliers-tab" data-bs-toggle="tab" data-bs-target="#suppliers-pane" type="button" role="tab" aria-controls="suppliers-pane" [attr.aria-selected]="activeTab === 'suppliers'">
            <i class="bi bi-truck me-2"></i>Suppliers
          </button>
        </li>
        <li class="nav-item" role="presentation" *ngIf="!singleTabView && userRole === 'Admin User'">
          <button class="nav-link" [class.active]="activeTab === 'subscription'" (click)="changeTab('subscription')" id="subscription-tab" data-bs-toggle="tab" data-bs-target="#subscription-pane" type="button" role="tab" aria-controls="subscription-pane" [attr.aria-selected]="activeTab === 'subscription'">
            <i class="bi bi-credit-card-fill me-2"></i>Subscription
          </button>
        </li>
      </ul>
    </div>

    <!-- Tab Content -->
    <div class="card-body p-4">
      <div class="tab-content">
        <!-- Users Tab -->
        <div class="tab-pane fade" [class.show]="activeTab === 'users'" [class.active]="activeTab === 'users'" id="users-pane" role="tabpanel" aria-labelledby="users-tab" tabindex="0">
          <app-section-card variant="users" icon="bi-people-fill" title="User Management" subtitle="Manage system users and their permissions">
            <button sectionActions class="btn btn-teal-gradient text" (click)="showAddUserModal()">
              <i class="bi bi-plus-lg me-1"></i>Add User
            </button>

          <div class="d-md-none">
            <div *ngIf="users.length === 0" class="text-center py-5">
              <div class="text-muted">
                <i class="fas fa-users-slash fa-2x mb-3"></i>
                <h5 class="mt-2">No users found</h5>
                <p class="mb-0">Add your first user by clicking the "Add User" button</p>
              </div>
            </div>

            <div *ngFor="let user of users" class="card mb-2">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start gap-2">
                  <div style="min-width: 0;">
                    <div class="fw-bold text-truncate">{{ user.firstName }} {{ user.lastName }}</div>
                    <div class="text-muted small text-truncate">{{ user.email }}</div>
                    <div class="mt-2 d-flex flex-wrap gap-2">
                      <span class="badge bg-teal-soft text-teal">
                        <i class="fas fa-user-tag me-1"></i>
                        {{ user.roleName || 'No Role' }}
                      </span>
                      <span class="badge rounded-pill" [ngClass]="user.isActive ? 'bg-success-soft text-success' : 'bg-danger-soft text-danger'">
                        {{ user.isActive ? 'Active' : 'Inactive' }}
                      </span>
                    </div>
                  </div>

                  <div class="text-nowrap">
                    <button class="btn btn-outline-primary btn-sm me-1 action-button" (click)="editUser(user)" title="Edit User">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                    <button class="btn btn-outline-warning btn-sm me-1 action-button" (click)="resetUserPassword(user)" title="Reset Password">
                      <i class="bi bi-key"></i>
                    </button>
                    <button *ngIf="user.roleName !== 'Admin User'" class="btn btn-outline-danger btn-sm action-button" (click)="confirmDeleteUser(user)" title="Delete User">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="table-responsive d-none d-md-block">
            <table class="table table-hover align-middle">
              <thead class="table-light">
                <tr>
                  <th (click)="sortUsers('username')" style="cursor: pointer;" class="border-0">
                    <span class="d-flex align-items-center">
                      Name
                      <i class="fas fa-sort ms-1" [class.text-teal]="currentSort.field === 'username'"></i>
                    </span>
                  </th>
                  <th (click)="sortUsers('email')" style="cursor: pointer;" class="border-0">
                    <span class="d-flex align-items-center">
                      Email
                      <i class="fas fa-sort ms-1" [class.text-teal]="currentSort.field === 'email'"></i>
                    </span>
                  </th>
                  <th (click)="sortUsers('roleName')" style="cursor: pointer;" class="border-0">
                    <span class="d-flex align-items-center">
                      Role
                      <i class="fas fa-sort ms-1" [class.text-teal]="currentSort.field === 'roleName'"></i>
                    </span>
                  </th>
                  <th (click)="sortUsers('isActive')" style="cursor: pointer;" class="border-0">
                    <span class="d-flex align-items-center">
                      Status
                      <i class="fas fa-sort ms-1" [class.text-teal]="currentSort.field === 'isActive'"></i>
                    </span>
                  </th>
                  <th *ngIf="userRole === 'Admin User'" class="border-0">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let user of users" class="border-top">
                  <td class="align-middle">
                    <div>
                      <h6 class="mb-0">{{ user.firstName }} {{ user.lastName }}</h6>

                    </div>
                  </td>
                  <td class="align-middle">
                    <a href="mailto:{{ user.email }}" class="text-body">{{ user.email }}</a>
                  </td>
                  <td class="align-middle">
                    <span class="badge bg-teal-soft text-teal">
                      <i class="fas fa-user-tag me-1"></i>
                      {{ user.roleName || 'No Role' }}
                    </span>
                  </td>
                  <td class="align-middle">
                    <span class="badge rounded-pill" [ngClass]="user.isActive ? 'bg-success-soft text-success' : 'bg-danger-soft text-danger'">
                      <i class="fas fa-circle me-1" [class.text-success]="user.isActive" [class.text-danger]="!user.isActive" style="font-size: 0.5rem;"></i>
                      {{ user.isActive ? 'Active' : 'Inactive' }}
                    </span>
                  </td>
                  <td *ngIf="userRole === 'Admin User'" class="text-nowrap">
                    <button class="btn btn-outline-primary btn-sm me-1 action-button" (click)="editUser(user)" title="Edit User">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                    <button class="btn btn-outline-warning btn-sm me-1 action-button" (click)="resetUserPassword(user)" title="Reset Password">
                      <i class="bi bi-key"></i>
                    </button>
                    <button *ngIf="user.roleName !== 'Admin User'" class="btn btn-outline-danger btn-sm action-button" (click)="confirmDeleteUser(user)" title="Delete User">
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="users.length === 0" class="border-top">
                  <td colspan="5" class="text-center py-5">
                    <div class="text-muted">
                      <i class="fas fa-users-slash fa-2x mb-3"></i>
                      <h5 class="mt-2">No users found</h5>
                      <p class="mb-0">Add your first user by clicking the "Add User" button</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          </app-section-card>
        </div>

        <!-- Categories Tab -->
        <div class="tab-pane fade" [class.show]="activeTab === 'categories'" [class.active]="activeTab === 'categories'" id="categories-pane" role="tabpanel" aria-labelledby="categories-tab" tabindex="0">
          <app-section-card variant="categories" icon="bi-tags-fill" title="Category Management" subtitle="Organize your inventory with categories">
            <button sectionActions class="btn btn-teal-gradient text" (click)="showAddCategoryModal()">
              <i class="bi bi-plus-lg me-1"></i>Add Category
            </button>

          <div class="d-md-none">
            <div *ngIf="categories.length === 0" class="text-center py-5">
              <div class="text-muted">
                <i class="fas fa-tags fa-2x mb-3"></i>
                <h5 class="mt-2">No categories found</h5>
                <p class="mb-0">Create your first category by clicking the "Add Category" button</p>
              </div>
            </div>

            <div *ngFor="let category of categories" class="card mb-2">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center gap-2">
                  <div class="fw-bold" style="min-width: 0;">
                    <div class="text-truncate">{{ category.categoryName }}</div>
                  </div>
                  <div class="text-nowrap">
                    <button class="btn-outline-primary" (click)="editCategory(category)">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                    <button class="btn-outline-primary danger" (click)="confirmDeleteCategory(category)">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="table-responsive d-none d-md-block">
            <table class="table table-hover align-middle">
              <thead class="table-light">
                <tr>
                  <th (click)="sortCategories('categoryName')" style="cursor: pointer;" class="border-0">
                    <span class="d-flex align-items-center">
                      Category Name
                      <i class="fas fa-sort ms-1" [class.text-teal]="currentSort.field === 'categoryName'"></i>
                    </span>
                  </th>
                  <th class="border-0">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let category of categories" class="border-top">
                  <td class="align-middle">
                    <div class="d-flex align-items-center">
                      <div>
                        <h6 class="mb-0">{{ category.categoryName }}</h6>

                      </div>
                    </div>
                  </td>
                  <td class="text-nowrap">
                    <button class="btn-outline-primary" (click)="editCategory(category)">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                    <button class="btn-outline-primary danger" (click)="confirmDeleteCategory(category)">
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="categories.length === 0" class="border-top">
                  <td colspan="5" class="text-center py-5">
                    <div class="text-muted">
                      <i class="fas fa-tags fa-2x mb-3"></i>
                      <h5 class="mt-2">No categories found</h5>
                      <p class="mb-0">Create your first category by clicking the "Add Category" button</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          </app-section-card>
        </div>

        <!-- Subscriptions Tab -->
        <div class="tab-pane fade" [class.show]="activeTab === 'subscription'" [class.active]="activeTab === 'subscription'" id="subscription-pane" role="tabpanel" aria-labelledby="subscription-tab" tabindex="0">
          <app-section-card variant="subscription" icon="bi-credit-card-2-front-fill" title="Subscription Management" subtitle="Manage your tenant subscription">

          <!-- Current Subscription Card -->
          <div *ngIf="subscriptions.length > 0" class="card border-0 shadow-sm mb-4">
            <div class="card-body p-4">
              <div class="row">
                <div class="col-md-6">
                  <ng-container *ngIf="subscriptions[0]?.status === 'active'; else trialBlock">
                    <h5 class="card-title">Click the button to manage your subscription</h5>
                    <div class="mb-3">
                      <span class="text-muted">This will navigate to the subscription page on Paystack</span>
                    </div>
                  </ng-container>
                  <ng-template #trialBlock>
                    <h5 class="card-title">Trial period</h5>
                    <div class="mb-2">
                      <span class="text-muted">Management link is unavailable during trial.</span><span  *ngIf="subscriptions[0]?.status === 'active'"> You can cancel the trial below.</span>
                    </div>
                  </ng-template>
                </div>

              </div>

              <!-- Subscription Actions -->
              <div class="mt-4 d-flex gap-2">
                <!-- Manage: show whenever subscription exists and is not a trial (backend queries Paystack directly) -->
                <button
                  *ngIf="subscriptions[0] && subscriptions[0]?.status !== 'trial'"
                  (click)="generateUpdateLink()"
                  [disabled]="isLoading"
                  class="btn btn-teal-gradient text flex-fill"
                >
                  Manage Subscription
                </button>

                <!-- Trial: allow cancel trial locally -->
                <button
                  *ngIf="subscriptions[0]?.status === 'trial'"
                  (click)="cancelTrialNow()"
                  [disabled]="isProcessingSubscription"
                  class="btn btn-outline-danger flex-fill"
                >
                  Cancel Trial
                </button>

                <!-- Change Plan / Renew: always available when not on trial -->
                <button
                  *ngIf="subscriptions[0] && subscriptions[0]?.status !== 'trial'"
                  (click)="renewSubscriptionNow()"
                  [disabled]="isProcessingSubscription"
                  class="btn btn-success flex-fill"
                >
                  {{ subscriptions[0].status === 'active' ? 'Change Plan' : 'Renew Subscription' }}
                </button>

              </div>
            </div>
          </div>
          </app-section-card>
        </div>

        <!-- Roles Tab -->
        <div class="tab-pane fade" [class.show]="activeTab === 'roles'" [class.active]="activeTab === 'roles'" id="roles-pane" role="tabpanel" aria-labelledby="roles-tab" tabindex="0">
          <app-section-card variant="roles" icon="bi-shield-lock-fill" title="Role Management" subtitle="Define user roles and their permissions">
            <button sectionActions class="btn btn-teal-gradient text" (click)="showAddRoleModal()">
              <i class="bi bi-plus-lg me-1"></i>Add Worker Role
            </button>

          <!-- Admin Roles Section -->
          <div class="card " *ngIf="!(isRoleView && singleTabView)">
            <div class="card-header bg-light">
              <h5 class="mb-0">
                System Roles

              </h5>
              <small sty>System roles are predefined roles that cannot be deleted</small>

            </div>
            <div class="card-body p-0">
              <div class="d-md-none p-3">
                <div *ngIf="getAdminRoles().length === 0" class="text-center py-4">
                  <div class="text-muted">
                    <i class="fas fa-shield-alt fa-2x mb-2"></i>
                    <p class="mb-0">No admin roles found</p>
                  </div>
                </div>

                <div *ngFor="let role of getAdminRoles()" class="card mb-2">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-start gap-2">
                      <div style="min-width: 0;">
                        <div class="fw-bold text-truncate">{{ role.roleName }}</div>
                        <div class="text-muted small text-truncate">{{ role.description || 'No description provided' }}</div>
                      </div>
                      <span class="badge bg-primary-soft text-primary rounded-pill px-3 py-2">
                        <i class="fas fa-users me-1"></i>
                        {{ getUserCount(role.roleID) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="table-responsive d-none d-md-block">
                <table class="table table-hover align-middle mb-0">
                  <thead class="table-light">
                    <tr>
                      <th class="border-0">Role Name</th>
                      <th class="border-0">Description</th>
                      <th class="border-0 text-center">Users</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let role of getAdminRoles()" class="border-top">
                      <td class="align-middle">
                        <div class="d-flex align-items-center">
                          <i class="fas fa-shield-alt text-primary me-2"></i>
                          <h6 class="mb-0">{{ role.roleName }}</h6>
                        </div>
                      </td>
                      <td class="align-middle">
                        <p class="mb-0 text-truncate" style="max-width: 250px;" [title]="role.description || 'No description'">
                          {{ role.description || 'No description provided' }}
                        </p>
                      </td>
                      <td class="align-middle text-center">
                        <span class="badge bg-primary-soft text-primary rounded-pill px-3 py-2">
                          <i class="fas fa-users me-1"></i>
                          {{ getUserCount(role.roleID) }} users
                        </span>
                      </td>

                    </tr>
                    <tr *ngIf="getAdminRoles().length === 0" class="border-top">
                      <td colspan="4" class="text-center py-4">
                        <div class="text-muted">
                          <i class="fas fa-shield-alt fa-2x mb-2"></i>
                          <p class="mb-0">No admin roles found</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Worker Roles Section -->
          <div class="card">

            <div class="card-header bg-light">
              <h5 class="mb-0">
                Worker Roles

              </h5>
              <small>Worker roles are roles that are specific to the workers for use in the cost calculator</small>

            </div>
            <div class="card-body p-0">
              <div class="d-md-none p-3">
                <div *ngIf="getWorkerRoles().length === 0" class="text-center py-4">
                  <div class="text-muted">
                    <i class="fas fa-user-tag fa-2x mb-2"></i>
                    <p class="mb-0">No worker roles found</p>
                  </div>
                </div>

                <div *ngFor="let role of getWorkerRoles()" class="card mb-2">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-start gap-2">
                      <div style="min-width: 0;">
                        <div class="fw-bold text-truncate">{{ role.roleName }}</div>
                        <div class="text-muted small text-truncate">{{ role.description || 'No description provided' }}</div>
                        <div class="mt-2">
                          <span class="badge bg-teal-soft text-teal rounded-pill px-3 py-2">
                            <i class="fas fa-users me-1"></i>
                            {{ getUserCount(role.roleID) }} users
                          </span>
                        </div>
                      </div>
                      <div class="text-nowrap">
                        <button class="btn btn-sm btn-outline-primary me-1" (click)="editRole(role)" title="Edit">
                          <i class="bi bi-pencil-square"></i>
                        </button>
                        <button class="btn btn-sm btn-outline-danger" (click)="confirmDeleteRole(role)" title="Delete">
                          <i class="bi bi-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="table-responsive d-none d-md-block">
                <table class="table table-hover align-middle mb-0">
                  <thead class="table-light">
                    <tr>
                      <th class="border-0">Role Name</th>
                      <th class="border-0">Description</th>
                      <th class="border-0 text-center">Users</th>
                      <th class="border-0">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let role of getWorkerRoles()" class="border-top">
                      <td class="align-middle">
                        <div class="d-flex align-items-center">
                          <i class="fas fa-user-tag text-teal me-2"></i>
                          <h6 class="mb-0">{{ role.roleName }}</h6>
                        </div>
                      </td>
                      <td class="align-middle">
                        <p class="mb-0 text-truncate" style="max-width: 250px;" [title]="role.description || 'No description'">
                          {{ role.description || 'No description provided' }}
                        </p>
                      </td>
                      <td class="align-middle text-center">
                        <span class="badge bg-teal-soft text-teal rounded-pill px-3 py-2">
                          <i class="fas fa-users me-1"></i>
                          {{ getUserCount(role.roleID) }} users
                        </span>
                      </td>
                      <td class="text-nowrap">
                        <button class="btn btn-sm btn-outline-primary me-1" (click)="editRole(role)" title="Edit">
                          <i class="bi bi-pencil-square"></i>
                        </button>
                        <button class="btn btn-sm btn-outline-danger" (click)="confirmDeleteRole(role)" title="Delete">
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                    <tr *ngIf="getWorkerRoles().length === 0" class="border-top">
                      <td colspan="4" class="text-center py-4">
                        <div class="text-muted">
                          <i class="fas fa-user-tag fa-2x mb-2"></i>
                          <p class="mb-0">No worker roles found</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          </app-section-card>
        </div>
        <!-- Supplier Tab -->
        <div class="tab-pane fade" [class.show]="activeTab === 'suppliers'" [class.active]="activeTab === 'suppliers'" id="suppliers-pane" role="tabpanel" aria-labelledby="suppliers-tab" tabindex="0">
          <app-section-card variant="suppliers" icon="bi-truck" title="Supplier Management" subtitle="Manage your suppliers and their locations">
            <button sectionActions class="btn btn-teal-gradient text" (click)="addSupplier()">
              <i class="bi bi-plus-lg me-1"></i>Add Supplier
            </button>

          <div class="d-md-none">
            <div *ngIf="!suppliers.length" class="text-center py-4">
              <div class="text-muted">No suppliers found. Click 'Add Supplier' to get started.</div>
            </div>

            <div *ngFor="let supplier of suppliers" class="card mb-2">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start gap-2">
                  <div style="min-width: 0;">
                    <div class="fw-bold text-truncate">{{ supplier.companyName }}</div>
                    <div class="text-muted small">{{ supplier.primaryEmail || '-' }}</div>
                    <div class="mt-2 d-flex flex-wrap gap-2">
                      <span class="badge rounded-pill" [ngClass]="supplier.isActive ? 'bg-success-soft text-success' : 'bg-danger-soft text-danger'">
                        {{ supplier.isActive ? 'Active' : 'Inactive' }}
                      </span>
                      <span class="badge rounded-pill bg-secondary" *ngIf="!supplier.locations?.length">No locations</span>
                      <span class="badge bg-teal-soft text-teal" *ngIf="supplier.locations?.length">{{ supplier.locations?.length }} location(s)</span>
                    </div>
                  </div>

                  <div class="text-nowrap">
                    <ng-container *ngIf="supplier.companyName !== 'Unlisted'">
                      <button class="btn-outline-primary" (click)="editSupplier(supplier)">
                        <i class="bi bi-pencil-square"></i>
                      </button>
                      <button class="btn-outline-primary danger" (click)="confirmDeleteSupplier(supplier)">
                        <i class="bi bi-trash"></i>
                      </button>
                    </ng-container>
                  </div>
                </div>

                <div *ngIf="supplier.locations?.length" class="mt-2">
                  <div class="small text-muted">Locations</div>
                  <div *ngFor="let loc of supplier.locations" class="small">
                    {{ loc.branchName || 'Main' }} ({{ loc.city || 'N/A' }})
                    <span class="badge loc-type-badge ms-1">{{ loc.isPhysical !== false ? 'Physical' : 'Postal' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="table-responsive d-none d-md-block">
            <table class="table table-hover align-middle">
              <thead class="table-light">
                <tr>
                  <th>Company Name</th>
                  <th>Contact Person</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Locations</th>
                  <th>Status</th>
                  <th class="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let supplier of suppliers">
                  <td>{{ supplier.companyName }}</td>
                  <td>{{ supplier.primaryContactPerson || '-' }}</td>
                  <td>{{ supplier.primaryEmail || '-' }}</td>
                  <td>{{ supplier.primaryPhone || '-' }}</td>
                  <td>
                    <span class="badge rounded-pill bg-secondary" *ngIf="!supplier.locations?.length">No locations</span>
                    <div *ngFor="let loc of supplier.locations" class="mb-1">
                      {{ loc.branchName || 'Main' }} ({{ loc.city || 'N/A' }})
                      <span class="badge loc-type-badge ms-1">{{ loc.isPhysical !== false ? 'Physical' : 'Postal' }}</span>
                    </div>
                  </td>
                  <td>
                    <span class="badge rounded-pill" [ngClass]="supplier.isActive ? 'bg-success-soft text-success' : 'bg-danger-soft text-danger'"> {{ supplier.isActive ? 'Active' : 'Inactive' }}</span>
                  </td>
                  <td class="text-right">
                    <ng-container *ngIf="supplier.companyName !== 'Unlisted'">
                      <button class="btn-outline-primary" (click)="editSupplier(supplier)">
                        <i class="bi bi-pencil-square"></i>
                      </button>
                      <button class="btn-outline-primary danger" (click)="confirmDeleteSupplier(supplier)">
                        <i class="bi bi-trash"></i>
                      </button>
                    </ng-container>
                  </td>

                </tr>
                <tr *ngIf="!suppliers.length">
                  <td colspan="7" class="text-center py-4">
                    <div class="text-muted">No suppliers found. Click 'Add Supplier' to get started.</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          </app-section-card>
        </div>




      </div>
    </div>
  </div>
</div>
</div>

<!-- ===================== MOBILE VIEW ===================== -->
<app-mobile-page-shell [hideBottomNav]="true" class="d-block d-md-none">

  <!-- Mobile Content -->
  <div class="form-stack">

    <!-- Users Tab (Mobile) -->
    <div *ngIf="activeTab === 'users'">
      <app-section-card variant="users" icon="bi-people-fill" title="User Management" subtitle="Manage system users and their permissions">
        <div class="m-cfg-toolbar">
          <div class="m-cfg-search">
            <i class="bi bi-search"></i>
            <input type="text" [(ngModel)]="mobileUserSearch" placeholder="Search users…" />
            <button *ngIf="mobileUserSearch" (click)="mobileUserSearch=''" class="m-cfg-clear"><i class="bi bi-x"></i></button>
          </div>
          <div class="m-cfg-controls">
            <div class="m-cfg-chips">
              <button [class.active]="mobileUserStatus==='all'" (click)="mobileUserStatus='all'">All</button>
              <button [class.active]="mobileUserStatus==='active'" (click)="mobileUserStatus='active'">Active</button>
              <button [class.active]="mobileUserStatus==='inactive'" (click)="mobileUserStatus='inactive'">Inactive</button>
            </div>
            <button class="m-cfg-sort" (click)="mobileUserSortAsc=!mobileUserSortAsc">
              <i class="bi" [class.bi-sort-alpha-down]="mobileUserSortAsc" [class.bi-sort-alpha-up]="!mobileUserSortAsc"></i>
            </button>
          </div>
        </div>
      </app-section-card>

      <div class="m-cfg-list">
        <div *ngIf="users.length === 0" class="text-center py-5">
          <div class="text-muted">
            <i class="fas fa-users-slash fa-2x mb-3"></i>
            <h5 class="mt-2">No users found</h5>
            <p class="mb-0">Add your first user</p>
          </div>
        </div>
        <app-mobile-data-card
          *ngFor="let user of filteredUsersMobile(); let i = index"
          [title]="user.firstName + ' ' + user.lastName"
          [fields]="[
            { label: 'Email', value: user.email },
            { label: 'Role', value: user.roleName || 'No Role' },
            { label: 'Status', value: user.isActive ? 'Active' : 'Inactive', type: 'status' }
          ]"
          [animationDelay]="i * 60"
          [fullItem]="user"
          (editTap)="editUserMobile($event)"
          (deleteTap)="confirmDeleteUser($event)"
          (resetPasswordTap)="requestResetPasswordMobile($event)">
        </app-mobile-data-card>
        <div *ngIf="filteredUsersMobile().length === 0 && users.length > 0" class="m-cfg-empty">No matches</div>
      </div>
    </div>

    <!-- Roles Tab (Mobile) -->
    <div *ngIf="activeTab === 'roles'">
      <app-section-card variant="roles" icon="bi-shield-lock-fill" title="Role Management" subtitle="Define user roles and their permissions">
        <div class="m-cfg-toolbar m-cfg-toolbar--inline">
          <div class="m-cfg-search">
            <i class="bi bi-search"></i>
            <input type="text" [(ngModel)]="mobileRoleSearch" placeholder="Search roles…" />
            <button *ngIf="mobileRoleSearch" (click)="mobileRoleSearch=''" class="m-cfg-clear"><i class="bi bi-x"></i></button>
          </div>
          <button class="m-cfg-sort" (click)="mobileRoleSortAsc=!mobileRoleSortAsc">
            <i class="bi" [class.bi-sort-alpha-down]="mobileRoleSortAsc" [class.bi-sort-alpha-up]="!mobileRoleSortAsc"></i>
          </button>
        </div>
      </app-section-card>

      <div class="m-cfg-list">
        <!-- Admin Roles -->
        <div *ngIf="filteredAdminRolesMobile().length > 0">
          <div class="m-role-group-header mx-3 mt-3">
            <h6 class="mb-1">System Roles</h6>
            <small class="text-muted">System roles are predefined and cannot be deleted</small>
          </div>
          <app-mobile-data-card
            *ngFor="let role of filteredAdminRolesMobile(); let i = index"
            [title]="role.roleName"
            [fields]="[
              { label: 'Description', value: role.description || 'No description' },
              { label: 'Users', value: getUserCount(role.roleID) + ' users', tone: 'primary' }
            ]"
            [animationDelay]="i * 60"
            [fullItem]="role">
          </app-mobile-data-card>
        </div>

        <!-- Worker Roles -->
        <div *ngIf="filteredWorkerRolesMobile().length > 0">
          <div class="m-role-group-header mx-3 mt-3">
            <h6 class="mb-1">Worker Roles</h6>
            <small class="text-muted">Worker roles can be customised and assigned to team members</small>
          </div>
          <app-mobile-data-card
            *ngFor="let role of filteredWorkerRolesMobile(); let i = index"
            [title]="role.roleName"
            [fields]="[
              { label: 'Description', value: role.description || 'No description' },
              { label: 'Users', value: getUserCount(role.roleID) + ' users', tone: 'primary' }
            ]"
            [animationDelay]="(filteredAdminRolesMobile().length + i) * 60"
            [fullItem]="role"
            (editTap)="editRoleMobile($event)"
            (deleteTap)="confirmDeleteRole($event)">
          </app-mobile-data-card>
        </div>

        <div *ngIf="filteredAdminRolesMobile().length === 0 && filteredWorkerRolesMobile().length === 0 && roles.length > 0" class="m-cfg-empty">No matches</div>
        <div *ngIf="getAdminRoles().length === 0 && getWorkerRoles().length === 0" class="text-center py-5">
          <div class="text-muted">
            <i class="fas fa-user-tag fa-2x mb-3"></i>
            <h5 class="mt-2">No roles found</h5>
          </div>
        </div>
      </div>
    </div>

    <!-- Categories Tab (Mobile) -->
    <div *ngIf="activeTab === 'categories'">
      <app-section-card variant="categories" icon="bi-tags-fill" title="Category Management" subtitle="Organize your inventory with categories">
        <div class="m-cfg-toolbar m-cfg-toolbar--inline">
          <div class="m-cfg-search">
            <i class="bi bi-search"></i>
            <input type="text" [(ngModel)]="mobileCategorySearch" placeholder="Search categories…" />
            <button *ngIf="mobileCategorySearch" (click)="mobileCategorySearch=''" class="m-cfg-clear"><i class="bi bi-x"></i></button>
          </div>
          <button class="m-cfg-sort" (click)="mobileCategorySortAsc=!mobileCategorySortAsc">
            <i class="bi" [class.bi-sort-alpha-down]="mobileCategorySortAsc" [class.bi-sort-alpha-up]="!mobileCategorySortAsc"></i>
          </button>
        </div>
      </app-section-card>

      <div class="m-cfg-list">
        <div *ngIf="categories.length === 0" class="text-center py-5">
          <div class="text-muted">
            <i class="fas fa-tags fa-2x mb-3"></i>
            <h5 class="mt-2">No categories found</h5>
          </div>
        </div>
        <div class="m-cat-list">
          <div class="m-cat-row" *ngFor="let cat of filteredCategoriesMobile(); let i = index"
               [style.animation-delay.ms]="i * 40">
            <span class="m-cat-name">{{ cat.categoryName }}</span>
            <div class="m-cat-actions">
              <button type="button" class="m-cat-btn m-cat-btn--edit"
                      (click)="editCategoryMobile(cat)" aria-label="Edit category">
                <i class="bi bi-pencil"></i>
              </button>
              <button type="button" class="m-cat-btn m-cat-btn--delete"
                      (click)="confirmDeleteCategory(cat)" aria-label="Delete category">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="filteredCategoriesMobile().length === 0 && categories.length > 0" class="m-cfg-empty">No matches</div>
      </div>
    </div>

    <!-- Suppliers Tab (Mobile) -->
    <div *ngIf="activeTab === 'suppliers'">
      <div *ngIf="navigationSource === 'inventory'" class="m-cfg-back-banner">
        <button class="btn btn-outline-secondary btn-sm" (click)="goBack()">
          <i class="bi bi-arrow-left me-1"></i> Back to Inventory
        </button>
      </div>
      <app-section-card variant="suppliers" icon="bi-truck" title="Supplier Management" subtitle="Manage your suppliers and their locations">
        <div class="m-cfg-toolbar">
          <div class="m-cfg-search">
            <i class="bi bi-search"></i>
            <input type="text" [(ngModel)]="mobileSupplierSearch" placeholder="Search suppliers…" />
            <button *ngIf="mobileSupplierSearch" (click)="mobileSupplierSearch=''" class="m-cfg-clear"><i class="bi bi-x"></i></button>
          </div>
          <div class="m-cfg-controls">
            <div class="m-cfg-chips">
              <button [class.active]="mobileSupplierStatus==='all'" (click)="mobileSupplierStatus='all'">All</button>
              <button [class.active]="mobileSupplierStatus==='active'" (click)="mobileSupplierStatus='active'">Active</button>
              <button [class.active]="mobileSupplierStatus==='inactive'" (click)="mobileSupplierStatus='inactive'">Inactive</button>
            </div>
            <button class="m-cfg-sort" (click)="mobileSupplierSortAsc=!mobileSupplierSortAsc">
              <i class="bi" [class.bi-sort-alpha-down]="mobileSupplierSortAsc" [class.bi-sort-alpha-up]="!mobileSupplierSortAsc"></i>
            </button>
          </div>
        </div>
      </app-section-card>

      <div class="m-cfg-list">
        <div *ngIf="suppliers.length === 0" class="text-center py-5">
          <div class="text-muted">
            <i class="fas fa-truck fa-2x mb-3"></i>
            <h5 class="mt-2">No suppliers found</h5>
          </div>
        </div>
        <app-mobile-data-card
          *ngFor="let supplier of filteredSuppliersMobile(); let i = index"
          [title]="supplier.companyName"
          [fields]="[
            { label: 'Contact', value: supplier.primaryContactPerson || '-' },
            { label: 'Email', value: supplier.primaryEmail || '-' },
            { label: 'Phone', value: supplier.primaryPhone || '-' },
            { label: 'Locations', value: formatSupplierLocations(supplier) },
            { label: 'Status', value: supplier.isActive ? 'Active' : 'Inactive', type: 'status' }
          ]"
          [animationDelay]="i * 60"
          [fullItem]="supplier"
          (editTap)="editSupplier($event)"
          (deleteTap)="confirmDeleteSupplier($event)">
        </app-mobile-data-card>
        <div *ngIf="filteredSuppliersMobile().length === 0 && suppliers.length > 0" class="m-cfg-empty">No matches</div>
      </div>
    </div>

    <!-- Subscription Tab (Mobile) -->
    <div *ngIf="activeTab === 'subscription'" class="mt-3">
      <div *ngIf="subscriptions.length > 0" class="m-section">
        <h6 class="m-section-title">Subscription Status</h6>
        <div class="m-field">
          <label>Status</label>
          <div class="form-control m-form-control disabled">
            {{ subscriptions[0].status | uppercase }}
          </div>
        </div>
        <div *ngIf="subscriptions[0]?.status === 'active'" class="m-subscription-note small mt-3">
          <div class="fw-semibold">Click the button to manage your subscription</div>
          <div class="text-muted">This will navigate to the subscription page on Paystack</div>
        </div>
        <div *ngIf="subscriptions[0]?.status !== 'trial'" class="mt-3 d-flex gap-2">
          <button class="btn btn-outline-primary w-100 m-cfg-action-btn" (click)="generateUpdateLink()" [disabled]="isLoading">
            <i class="bi bi-gear me-1"></i> Manage
          </button>
          <button class="btn btn-primary w-100 m-cfg-action-btn" (click)="renewSubscriptionNow()" [disabled]="isProcessingSubscription">
            <ng-container *ngIf="subscriptions[0].status === 'active'; else renewLabel">
              <i class="bi bi-arrow-left-right me-1"></i> Change Plan
            </ng-container>
            <ng-template #renewLabel><i class="bi bi-arrow-clockwise me-1"></i> Renew</ng-template>
          </button>
        </div>
        <div *ngIf="subscriptions[0]?.status === 'trial'" class="mt-3">
          <button class="btn btn-outline-danger w-100 m-cfg-action-btn" (click)="cancelTrialNow()" [disabled]="isProcessingSubscription">
            <i class="bi bi-x-lg me-1"></i> Cancel Trial
          </button>
        </div>
      </div>
    </div>

  </div>

  <!-- Mobile Action Bar -->
  <div class="m-action-bar">
    <button *ngIf="activeTab === 'users' && userRole === 'Admin User'"
      class="btn btn-primary w-100" (click)="showAddUserModalMobile()">
      <i class="bi bi-plus-lg me-1"></i> Add User
    </button>
    <button *ngIf="activeTab === 'roles' && userRole === 'Admin User'"
      class="btn btn-primary w-100" (click)="showAddRoleModalMobile()">
      <i class="bi bi-plus-lg me-1"></i> Add Worker Role
    </button>
    <button *ngIf="activeTab === 'categories' && !singleTabView"
      class="btn btn-primary w-100" (click)="showAddCategoryModalMobile()">
      <i class="bi bi-plus-lg me-1"></i> Add Category
    </button>
    <button *ngIf="activeTab === 'suppliers' && accountType !== 'calculator'"
      class="btn btn-primary w-100" (click)="addSupplier()">
      <i class="bi bi-plus-lg me-1"></i> Add Supplier
    </button>
  </div>

</app-mobile-page-shell>

<!-- Mobile Config Item Offcanvas -->
<app-config-item-offcanvas
  [visible]="mobileOffcanvasVisible"
  [mode]="mobileOffcanvasMode"
  [item]="mobileOffcanvasItem"
  [roles]="roles"
  [isEditing]="mobileOffcanvasIsEditing"
  (closeCanvas)="closeMobileOffcanvas()"
  (save)="onOffcanvasSave($event)">
</app-config-item-offcanvas>

<!-- Password Reset Confirmation Modal -->
<div class="modal" [ngClass]="{ 'd-block': showResetPasswordModal }" style="background: #00000080">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Reset Password</h5>
        <button type="button" class="close-button" (click)="closeResetPasswordModal()">×</button>
      </div>
      <div class="modal-body">
        <p>
          Are you sure you want to send a password reset link to
          <strong>{{ selectedUserForReset?.email }}</strong>?
          The user will receive an email with instructions to reset their password.
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-gradient-secondary" (click)="closeResetPasswordModal()">
          Cancel
        </button>
        <button class="btn btn-primary" (click)="confirmResetPassword()" [disabled]="isLoading">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          Send Reset Link
        </button>
      </div>
    </div>
  </div>
</div>

<!-- User Modal -->
<div class="modal fade show" [class.show]="showUserModal" *ngIf="showUserModal" tabindex="-1" style="display: block;" aria-modal="true" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ isEditingUser ? 'Edit User' : 'Add New User' }}</h5>
        <button type="button" class="btn-close" (click)="closeUserModal()" aria-label="Close" [disabled]="isSendingWelcomeEmail"></button>
      </div>
      <form [formGroup]="userForm" (ngSubmit)="saveUser()">
        <div class="modal-body">
          <div class="mb-3">
            <input type="text" style="display:none" autocomplete="username">
            <input type="password" style="display:none" autocomplete="new-password">
            <label class="form-label">Email</label>
            <input  type="text" class="form-control" formControlName="email" required>
            <div *ngIf="(userForm.get('email')?.hasError('required') || userForm.get('email')?.hasError('email')) && userForm.get('email')?.touched" class="text-danger">
              Please enter a valid email
            </div>
            <div *ngIf="userForm.get('email')?.hasError('duplicate') && userForm.get('email')?.touched" class="text-danger">
              This email is already in use
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">First Name</label>
            <input autocomplete="off" type="text" class="form-control" formControlName="firstName" required>
            <div *ngIf="userForm.get('firstName')?.invalid && userForm.get('firstName')?.touched" class="text-danger">
              First name is required
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">Last Name</label>
            <input  class="form-control" formControlName="lastName" required>
            <div *ngIf="userForm.get('lastName')?.invalid && userForm.get('lastName')?.touched" class="text-danger">
              Last name is required
            </div>
          </div>
          <div *ngIf="!isEditingUser" class="mb-3">
            <label class="form-label">Password</label>
            <div class="input-group">
              <input  [type]="showPassword ? 'text' : 'password'" class="form-control w-75" formControlName="password">
              <button class="btn btn-outline-secondary" type="button" (click)="togglePasswordVisibility()">
                <i class="bi" [class.bi-eye]="!showPassword" [class.bi-eye-slash]="showPassword"></i>
              </button>
            </div>
            <small class="text-muted">Leave blank to keep current password</small>
          </div>
          <div class="mb-3" *ngIf="!isEditingUser || (selectedUser && selectedUser.roleName !== 'Admin User')">
            <label class="form-label">Role</label>
            <select class="form-select" formControlName="roleID" [required]="!isEditingUser || !!(selectedUser && selectedUser.roleName !== 'Admin User')">
              <option value="">Select a role</option>
              <option *ngFor="let role of getAdminRoles()" [value]="role.roleID">{{ role.roleName }}</option>
            </select>
            <div *ngIf="userForm.get('roleID')?.invalid && userForm.get('roleID')?.touched" class="text-danger">
              Please select a role
            </div>
          </div>
          <div class="mb-3 d-flex align-items-center">
            <div class="form-check form-switch me-3">
              <input class="form-check-input" type="checkbox" id="isActive" formControlName="isActive">
            </div>
            <label class="form-check-label mb-0" for="isActive">Active</label>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-grey-gradient text" (click)="closeUserModal()" [disabled]="isSendingWelcomeEmail">Cancel</button>
          <button type="submit" class="btn btn-teal-gradient text" [disabled]="!isFormValid() || isSendingWelcomeEmail">
            <ng-container *ngIf="isSendingWelcomeEmail; else saveBtnLabel">
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Sending...
            </ng-container>
            <ng-template #saveBtnLabel>
              {{ isEditingUser ? 'Update' : 'Save' }}
            </ng-template>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Role Modal -->
<div class="modal fade show" [class.show]="showRoleModal" *ngIf="showRoleModal" tabindex="-1" style="display: block;" aria-modal="true" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ isEditingRole ? 'Edit Role' : 'Add New Worker Role' }}</h5>
        <button type="button" class="btn-close" (click)="closeRoleModal()" aria-label="Close"></button>
      </div>
      <form [formGroup]="roleForm" (ngSubmit)="saveRole()">
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label">Role Name</label>
            <input type="text" class="form-control" formControlName="roleName" required>
          </div>
          <div class="mb-3">
            <label class="form-label">Description</label>
            <textarea class="form-control" formControlName="description" rows="3"></textarea>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-grey-gradient" (click)="closeRoleModal()">Cancel</button>
          <button type="submit" class="btn btn-teal-gradient" [disabled]="roleForm.invalid">
            {{ isEditingRole ? 'Update' : 'Save' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Category Modal -->
<div class="modal fade show" [class.show]="showCategoryModal" *ngIf="showCategoryModal" tabindex="-1" style="display: block;" aria-modal="true" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ isEditingCategory ? 'Edit Category' : 'Add New Category' }}</h5>
        <button type="button" class="btn-close" (click)="closeCategoryModal()" aria-label="Close"></button>
      </div>
      <form [formGroup]="categoryForm" (ngSubmit)="saveCategory()">
        <div class="modal-body">
          <div class="mb-3">
            <label for="categoryName" class="form-label">Category Name</label>
            <input type="text" class="form-control" id="categoryName" formControlName="categoryName" required>
            <div *ngIf="categoryForm.get('categoryName')?.invalid && categoryForm.get('categoryName')?.touched" class="text-danger">
              Category name is required
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-grey-gradient text" (click)="closeCategoryModal()">Cancel</button>
          <button type="submit" class="btn btn-teal-gradient text" [disabled]="categoryForm.invalid">
            {{ isEditingCategory ? 'Update' : 'Save' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>




<!-- Delete Confirmation Modal -->
<!-- Delete Modal — Desktop -->
<div class="d-none d-md-block">
<div class="modal fade show" [class.show]="showDeleteModal" *ngIf="showDeleteModal" tabindex="-1" style="display: block;" aria-modal="true" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ deleteModalTitle }}</h5>
        <button type="button" class="btn-close" (click)="closeDeleteModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Are you sure you want to {{ itemToDelete?.type === 'user' ? 'deactivate' : 'delete' }} this {{ itemToDelete?.type }}?</p>
        <p class="text-danger">This action cannot be undone.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-grey-gradient text" (click)="closeDeleteModal()">Cancel</button>
        <button type="button" class="btn btn-teal-gradient danger text" (click)="deleteItem(undefined, itemToDelete?.type)">
          {{ itemToDelete?.type === 'user' ? 'Deactivate' : 'Delete' }}
        </button>
      </div>
    </div>
  </div>
</div>
</div>

<!-- Delete Confirmation — Mobile Bottom-Sheet -->
<div class="d-md-none">
  <div class="m-del-overlay" *ngIf="showDeleteModal || mobileDeleteClosing"
    [style.opacity]="mobileDeleteClosing ? 0 : (mobileDeleteSwipeActive ? (1 - mobileDeleteSwipeProgress * 0.6) : null)"
    [style.transition]="mobileDeleteClosing ? 'opacity 0.28s ease' : null"
    (click)="$event.target === $event.currentTarget && closeDeleteModal()">
    <div class="m-del-sheet" (click)="$event.stopPropagation()"
      [style.transform]="mobileDeleteClosing ? 'translateY(100%)' : (mobileDeleteSwipeDeltaY ? 'translateY(' + mobileDeleteSwipeDeltaY + 'px)' : null)"
      [style.transition]="mobileDeleteClosing ? 'transform 0.3s cubic-bezier(0.4,0,0.2,1)' : (mobileDeleteSwipeActive ? 'none' : 'transform 0.3s cubic-bezier(0.4,0,0.2,1)')">
      <div class="m-del-handle-bar"
        (touchstart)="onDeleteSheetTouchStart($event)"
        (touchmove)="onDeleteSheetTouchMove($event)"
        (touchend)="onDeleteSheetTouchEnd($event)">
        <div class="m-del-handle"
          [style.width.px]="36 + mobileDeleteSwipeProgress * 20"
          [style.background]="'rgb(' + Math.round(222 + mobileDeleteSwipeProgress * -222) + ',' + Math.round(226 + mobileDeleteSwipeProgress * (122 - 226)) + ',' + Math.round(230 + mobileDeleteSwipeProgress * (143 - 230)) + ')'"></div>
      </div>
      <div class="m-del-header">
        <h5 class="m-del-title">{{ deleteModalTitle }}</h5>
        <button class="m-del-close-btn" (click)="closeDeleteModal()"><i class="bi bi-x-lg"></i></button>
      </div>
      <div class="m-del-body">
        <p class="m-del-text">Are you sure you want to <strong class="text-danger">{{ itemToDelete?.type === 'user' ? 'deactivate' : 'delete' }}</strong> this {{ itemToDelete?.type }}? This action cannot be undone.</p>
      </div>
      <div class="m-del-footer">
        <button class="btn m-del-btn-cancel flex-fill" (click)="closeDeleteModal()">Cancel</button>
        <button class="btn m-del-btn-confirm flex-fill" (click)="deleteItem(undefined, itemToDelete?.type)">
          {{ itemToDelete?.type === 'user' ? 'Deactivate' : 'Delete' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Supplier Modal — Desktop -->
<div class="d-none d-md-block">
<div class="modal fade show" [class.show]="showSupplierModal" *ngIf="showSupplierModal" tabindex="-1" style="display: block; background-color: rgba(0,0,0,0.5);" aria-modal="true" role="dialog">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 1400px; width: 95%;">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h5 class="modal-title">{{ isEditingSupplier ? 'Edit' : 'Add New' }} Supplier</h5>
        <button type="button" class="btn-close" (click)="closeSupplierModal()" aria-label="Close"></button>
      </div>
      <form [formGroup]="supplierForm" (ngSubmit)="saveSupplier()">
        <div class="modal-body">
          <div class="card">
            <div class="card-header bg-light">
              <h6 class="mb-0">Supplier Details <span class="text-danger">*</span></h6>
              <small class="text-muted">Please provide details for the supplier</small>
            </div>
            <div class="card-body">
          <div class="mt-4">
            <div class="col-md-12">
              <label for="companyName" class="form-label">Company Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="companyName" formControlName="companyName"
                [class.is-invalid]="supplierForm.get('companyName')?.invalid && supplierForm.get('companyName')?.touched">
              <div class="invalid-feedback">Company name is required</div>
            </div>
            <div class="col-md-12">
              <label for="primaryContactPerson" class="form-label">Contact Person</label>
              <input type="text" class="form-control" id="primaryContactPerson" formControlName="primaryContactPerson">
            </div>
            <div class="col-md-12">
              <label for="primaryEmail" class="form-label">Email</label>
              <input type="email" class="form-control" id="primaryEmail" formControlName="primaryEmail"
                [class.is-invalid]="supplierForm.get('primaryEmail')?.invalid && supplierForm.get('primaryEmail')?.touched">
              <div class="invalid-feedback">Please enter a valid email address</div>
            </div>
            <div class="col-md-12">
              <label for="primaryPhone" class="form-label">Phone</label>
              <input type="tel" class="form-control" id="primaryPhone" formControlName="primaryPhone">
            </div>
            <div class="col-md-12">
              <label for="website" class="form-label">Website</label>
                <input   type="text" class="form-control" id="website" formControlName="website">
            </div>
            <div class="col-md-12">
              <label for="supplierCategoryID" class="form-label">Category</label>
              <select class="form-select" id="supplierCategoryID" formControlName="supplierCategoryID">
                <option [ngValue]="null">Uncategorized</option>
                <option *ngFor="let cat of supplierCategories" [ngValue]="cat.supplierCategoryID">{{ cat.description }}</option>
              </select>
              <button type="button" class="btn btn-link btn-sm ps-0" *ngIf="!showQuickAddCategory" (click)="toggleQuickAddCategory(true)">
                + Add new category
              </button>
              <div class="input-group input-group-sm mt-2" *ngIf="showQuickAddCategory">
                <input type="text" class="form-control" placeholder="New category name" [(ngModel)]="newSupplierCategoryName" [ngModelOptions]="{standalone: true}">
                <button type="button" class="btn btn-outline-secondary" [disabled]="!newSupplierCategoryName.trim() || isSavingQuickAddCategory" (click)="quickAddSupplierCategory()">Save</button>
                <button type="button" class="btn btn-outline-secondary" (click)="toggleQuickAddCategory(false)">Cancel</button>
              </div>
            </div>
            <div class="mb-3 d-flex align-items-center" style="margin-top: 10px; margin-left: 10px;">
              <div class="form-check form-switch me-3" style="margin-left: 10px;">
                <input class="form-check-input" type="checkbox" id="isActive" formControlName="isActive">
              </div>
              <label class="form-check-label mb-0" for="isActive">Active</label>
            </div>
          </div>
          </div>
          </div>
          <!-- Initial Branch Section (Only shown when adding a new supplier) -->
          <div class="mt-4" *ngIf="!isEditingSupplier">
            <div class="card">
              <div class="card-header bg-light">
                <h6 class="mb-0">Primary Branch <span class="text-danger">*</span></h6>
                <small class="text-muted">Please provide details for the primary branch</small>
              </div>
              <div class="card-body">
                <div formArrayName="locations">
                  <div [formGroupName]="0">
                    <div class="row g-3">
                      <div class="col-md-6">
                        <label for="branchName" class="form-label">Branch Name</label>
                        <input type="text" class="form-control" id="branchName" formControlName="branchName"
                          [class.is-invalid]="getLocationFormGroup(0)?.get('branchName')?.invalid && getLocationFormGroup(0)?.get('branchName')?.touched">
                        <div class="invalid-feedback">Branch name is required</div>
                      </div>
                      <div class="col-md-6">
                        <label for="locationContactPerson" class="form-label">Contact Person</label>
                        <input type="text" class="form-control" id="locationContactPerson" formControlName="locationContactPerson">
                      </div>
                      <div class="col-md-6">
                        <label for="locationEmail" class="form-label">Email</label>
                        <input type="email" class="form-control" id="locationEmail" formControlName="locationEmail"
                          [class.is-invalid]="getLocationFormGroup(0)?.get('locationEmail')?.invalid && getLocationFormGroup(0)?.get('locationEmail')?.touched">
                        <div class="invalid-feedback">Please enter a valid email address</div>
                      </div>
                      <div class="col-md-6">
                        <label for="locationPhone" class="form-label">Phone</label>
                        <input type="tel" class="form-control" id="locationPhone" formControlName="locationPhone">
                      </div>
                      <div class="col-12">
                        <label for="addressLine1" class="form-label">Address Line 1</label>
                        <input type="text" class="form-control" id="addressLine1" formControlName="addressLine1">
                      </div>
                      <div class="col-12">
                        <label for="addressLine2" class="form-label">Address Line 2 (Optional)</label>
                        <input type="text" class="form-control" id="addressLine2" formControlName="addressLine2">
                      </div>
                      <div class="col-md-4">
                        <label for="city" class="form-label">City</label>
                        <input type="text" class="form-control" id="city" formControlName="city">
                      </div>
                      <div class="col-md-4">
                        <label for="region" class="form-label">State/Region</label>
                        <input type="text" class="form-control" id="region" formControlName="region">
                      </div>
                      <div class="col-md-4">
                        <label for="postalCode" class="form-label">Postal Code</label>
                        <input type="text" class="form-control" id="postalCode" formControlName="postalCode">
                      </div>
                      <div class="col-md-8">
                        <label for="country" class="form-label">Country</label>
                        <input type="text" class="form-control" id="country" formControlName="country">
                      </div>
                      <div class="col-md-4">
                        <label class="form-label">Address Type</label>
                        <div class="segmented-control" role="group" aria-label="Address type">
                          <div class="segmented-option" role="button" tabindex="0"
                               [class.active]="getLocationFormGroup(0)?.get('isPhysical')?.value"
                               (click)="getLocationFormGroup(0)?.get('isPhysical')?.setValue(true)"
                               (keydown.enter)="getLocationFormGroup(0)?.get('isPhysical')?.setValue(true)">
                            <i class="bi bi-geo-alt me-1"></i> Physical
                          </div>
                          <div class="segmented-option" role="button" tabindex="0"
                               [class.active]="!getLocationFormGroup(0)?.get('isPhysical')?.value"
                               (click)="getLocationFormGroup(0)?.get('isPhysical')?.setValue(false)"
                               (keydown.enter)="getLocationFormGroup(0)?.get('isPhysical')?.setValue(false)">
                            <i class="bi bi-envelope me-1"></i> Postal
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Existing Branches Section (Only shown when editing) -->
          <div class="mt-4" *ngIf="isEditingSupplier">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h6 class="mb-0">Branches</h6>
              <button type="button" class="btn btn-teal-gradient" (click)="showLocationForm()">
                <i class="bi bi-plus-lg me-1"></i> Add Branch
              </button>
            </div>

            <!-- Location Form -->
            <div class="card mb-3" *ngIf="isEditingLocation" [@slideInOut]>
              <div class="card-header bg-light d-flex justify-content-between align-items-center">
                <h6 class="mb-0">{{ isEditingSupplierLocation ? 'Edit' : 'Add' }} Branch</h6>
                <button type="button" class="btn-close" (click)="cancelLocationEdit()" aria-label="Close"></button>
              </div>
              <div class="card-body">
                <form [formGroup]="supplierLocationForm" (ngSubmit)="saveSupplierLocation()" style="overflow-y: auto; overflow-x: hidden;">
                  <div class="row g-2">
                    <div class="col-md-6">
                      <label class="form-label small text-muted mb-1">Branch Name</label>
                      <input type="text" class="form-control form-control-sm" formControlName="branchName" placeholder="e.g. Head Office">
                    </div>
                    <div class="col-md-6">
                      <label class="form-label small text-muted mb-1">Contact Person</label>
                      <input type="text" class="form-control form-control-sm" formControlName="locationContactPerson">
                    </div>
                    <div class="col-12">
                      <label class="form-label small text-muted mb-1">Address Line 1 <span class="text-danger">*</span></label>
                      <input type="text" class="form-control form-control-sm" formControlName="addressLine1" required>
                    </div>
                    <div class="col-12">
                      <label class="form-label small text-muted mb-1">Address Line 2</label>
                      <input type="text" class="form-control form-control-sm" formControlName="addressLine2">
                    </div>
                    <div class="col-md-6">
                      <label class="form-label small text-muted mb-1">City <span class="text-danger">*</span></label>
                      <input type="text" class="form-control form-control-sm" formControlName="city" required>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label small text-muted mb-1">Region</label>
                      <input type="text" class="form-control form-control-sm" formControlName="region">
                    </div>
                    <div class="col-md-6">
                      <label class="form-label small text-muted mb-1">Postal Code</label>
                      <input type="text" class="form-control form-control-sm" formControlName="postalCode">
                    </div>
                    <div class="col-md-6">
                      <label class="form-label small text-muted mb-1">Country <span class="text-danger">*</span></label>
                      <input type="text" class="form-control form-control-sm" formControlName="country" required>
                    </div>

                    <div class="col-md-6">
                      <label class="form-label small text-muted mb-1">Phone</label>
                      <input type="tel" class="form-control form-control-sm" formControlName="locationPhone">
                    </div>
                    <div class="col-md-6">
                      <label class="form-label small text-muted mb-1">Address Type</label>
                      <div class="segmented-control" role="group" aria-label="Address type">
                        <div class="segmented-option" role="button" tabindex="0"
                             [class.active]="supplierLocationForm.get('isPhysical')?.value"
                             (click)="supplierLocationForm.get('isPhysical')?.setValue(true)"
                             (keydown.enter)="supplierLocationForm.get('isPhysical')?.setValue(true)">
                          <i class="bi bi-geo-alt me-1"></i> Physical
                        </div>
                        <div class="segmented-option" role="button" tabindex="0"
                             [class.active]="!supplierLocationForm.get('isPhysical')?.value"
                             (click)="supplierLocationForm.get('isPhysical')?.setValue(false)"
                             (keydown.enter)="supplierLocationForm.get('isPhysical')?.setValue(false)">
                          <i class="bi bi-envelope me-1"></i> Postal
                        </div>
                      </div>
                    </div>
                    <div class="mb-3 d-flex align-items-center">
                      <div class="form-check form-switch me-3" style="margin-left: 10px;">
                        <input class="form-check-input" type="checkbox" id="isActive" formControlName="isActive">
                      </div>
                      <label class="form-check-label mb-0" for="isActive">Active</label>
                    </div>
                    <div class="col-12 text-end mt-2">
                      <button type="button" class="btn btn-sm btn-outline-secondary me-2" (click)="cancelLocationEdit()">
                        <i class="bi bi-x-lg me-1"></i> Cancel
                      </button>
                      <button type="submit" class="btn btn-sm btn-primary" [disabled]="supplierLocationForm.invalid">
                        <i class="bi bi-check-lg me-1"></i> {{ isEditingSupplierLocation ? 'Update' : 'Save' }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <!-- Locations List -->
            <div class="table-responsive" *ngIf="supplierForm.get('locations')?.value?.length">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <small class="text-muted">Manage branches for this supplier</small>

              </div>
              <div class="table-container">
                <table class="table table-sm table-hover">
                  <thead class="sticky-top bg-light">
                    <tr>
                      <th>Branch</th>
                      <th>Address</th>
                      <th>Type</th>
                      <th>Status</th>
                      <th class="text-end">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let loc of supplierForm.get('locations')?.value; let i = index">
                      <td class="align-middle">
                        <div class="fw-medium">{{ loc.branchName || 'Main' }}</div>
                        <small class="text-muted" *ngIf="loc.locationContactPerson">{{ loc.locationContactPerson }}</small>
                      </td>
                      <td class="align-middle">
                        <div *ngIf="loc.addressLine1" class="small">{{ loc.addressLine1 }}</div>
                        <div *ngIf="loc.city" class="small text-muted">
                          {{ loc.city }}{{ loc.region ? ', ' + loc.region : '' }}{{ loc.country ? ', ' + loc.country : '' }}
                        </div>
                      </td>
                      <td class="align-middle">
                        <span class="badge loc-type-badge">
                          <i class="bi" [ngClass]="loc.isPhysical !== false ? 'bi-geo-alt' : 'bi-envelope'"></i>
                          {{ loc.isPhysical !== false ? 'Physical' : 'Postal' }}
                        </span>
                      </td>
                      <td class="align-middle">
                        <span class="badge" [ngClass]="loc.isActive ? 'bg-success' : 'bg-secondary'">
                          {{ loc.isActive ? 'Active' : 'Inactive' }}
                        </span>
                      </td>
                      <td class="text-end align-middle">
                        <div class="btn-group btn-group-sm">
                          <button type="button" class="btn btn-sm btn-outline-primary" (click)="editSupplierLocation(loc)" [disabled]="isEditingLocation">
                            <i class="bi bi-pencil"></i>
                          </button>

                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" (click)="closeSupplierModal()">Cancel</button>
          <button type="submit" class="btn btn-primary" [disabled]="supplierForm.invalid">
            {{ isEditingSupplier ? 'Finish Updating Supplier' : 'Save Supplier' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
</div><!-- end d-none d-md-block desktop supplier modal -->

<!-- Supplier Offcanvas — Mobile -->
<div class="d-md-none">
<div class="offcanvas-backdrop" *ngIf="showSupplierModal || supplierIsClosing"
  [style.opacity]="supplierIsClosing ? 0 : (supplierSwipeActive ? (1 - supplierSwipeProgress * 0.6) : null)"
  [style.transition]="supplierIsClosing ? 'opacity 0.28s ease' : null"
  (click)="$event.target === $event.currentTarget && closeSupplierModal()">
  <div class="offcanvas-sheet supplier-sheet" (click)="$event.stopPropagation()"
    [style.transform]="supplierIsClosing ? 'translateY(100%)' : (supplierSwipeDeltaY > 0 ? 'translateY(' + supplierSwipeDeltaY + 'px)' : null)"
    [style.transition]="supplierIsClosing ? 'transform 0.3s cubic-bezier(0.4,0,0.2,1)' : (supplierSwipeActive ? 'none' : 'transform 0.3s cubic-bezier(0.4,0,0.2,1)')">

    <div class="sheet-handle-bar"
      (touchstart)="onSupplierSheetTouchStart($event)"
      (touchmove)="onSupplierSheetTouchMove($event)"
      (touchend)="onSupplierSheetTouchEnd($event)">
      <div class="sheet-handle"
        [style.width.px]="36 + supplierSwipeProgress * 20"
        [style.background]="'rgb(' + Math.round(222 + supplierSwipeProgress * -222) + ',' + Math.round(226 + supplierSwipeProgress * (122 - 226)) + ',' + Math.round(230 + supplierSwipeProgress * (143 - 230)) + ')'">
      </div>
    </div>

    <div class="sheet-header">
      <h6 class="sheet-title">{{ isEditingSupplier ? 'Edit' : 'Add' }} Supplier</h6>
      <button class="sheet-close-btn" (click)="closeSupplierModal()" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="sheet-body">
      <form [formGroup]="supplierForm" (ngSubmit)="saveSupplier()">

        <!-- Supplier Details -->
        <div class="form-group-mobile">
          <label>Company Name <span class="text-danger">*</span></label>
          <input type="text" class="form-control" formControlName="companyName"
            [class.is-invalid]="supplierForm.get('companyName')?.invalid && supplierForm.get('companyName')?.touched">
          <div class="invalid-feedback">Company name is required</div>
        </div>
        <div class="form-group-mobile">
          <label>Contact Person</label>
          <input type="text" class="form-control" formControlName="primaryContactPerson">
        </div>
        <div class="form-group-mobile">
          <label>Email</label>
          <input type="email" class="form-control" formControlName="primaryEmail"
            [class.is-invalid]="supplierForm.get('primaryEmail')?.invalid && supplierForm.get('primaryEmail')?.touched">
          <div class="invalid-feedback">Please enter a valid email address</div>
        </div>
        <div class="form-group-mobile">
          <label>Phone</label>
          <input type="tel" class="form-control" formControlName="primaryPhone">
        </div>
        <div class="form-group-mobile">
          <label>Website</label>
          <input type="text" class="form-control" formControlName="website">
        </div>
        <div class="form-group-mobile">
          <label>Category</label>
          <select class="form-select" formControlName="supplierCategoryID">
            <option [ngValue]="null">Uncategorized</option>
            <option *ngFor="let cat of supplierCategories" [ngValue]="cat.supplierCategoryID">{{ cat.description }}</option>
          </select>
          <button type="button" class="btn btn-link btn-sm ps-0" *ngIf="!showQuickAddCategory" (click)="toggleQuickAddCategory(true)">
            + Add new category
          </button>
          <div class="input-group input-group-sm mt-2" *ngIf="showQuickAddCategory">
            <input type="text" class="form-control" placeholder="New category name" [(ngModel)]="newSupplierCategoryName" [ngModelOptions]="{standalone: true}">
            <button type="button" class="btn btn-outline-secondary" [disabled]="!newSupplierCategoryName.trim() || isSavingQuickAddCategory" (click)="quickAddSupplierCategory()">Save</button>
            <button type="button" class="btn btn-outline-secondary" (click)="toggleQuickAddCategory(false)">Cancel</button>
          </div>
        </div>
        <div class="form-group-mobile">
          <div class="form-check form-switch mt-1">
            <input class="form-check-input" type="checkbox" id="supplierIsActiveMobile" formControlName="isActive">
            <label class="form-check-label" for="supplierIsActiveMobile">Active</label>
          </div>
        </div>

        <!-- Primary Branch (Add only) -->
        <div *ngIf="!isEditingSupplier" formArrayName="locations">
          <div class="m-role-group-header mt-3 mb-2">
            <h6 class="mb-1">Primary Branch</h6>
            <small class="text-muted">Details for the main branch</small>
          </div>
          <div [formGroupName]="0">
            <div class="form-group-mobile">
              <label>Branch Name</label>
              <input type="text" class="form-control" formControlName="branchName">
            </div>
            <div class="form-group-mobile">
              <label>Contact Person</label>
              <input type="text" class="form-control" formControlName="locationContactPerson">
            </div>
            <div class="form-group-mobile">
              <label>Address Line 1</label>
              <input type="text" class="form-control" formControlName="addressLine1">
            </div>
            <div class="form-group-mobile">
              <label>Address Line 2</label>
              <input type="text" class="form-control" formControlName="addressLine2">
            </div>
            <div class="form-group-mobile">
              <label>City</label>
              <input type="text" class="form-control" formControlName="city">
            </div>
            <div class="form-group-mobile">
              <label>Region</label>
              <input type="text" class="form-control" formControlName="region">
            </div>
            <div class="form-group-mobile">
              <label>Postal Code</label>
              <input type="text" class="form-control" formControlName="postalCode">
            </div>
            <div class="form-group-mobile">
              <label>Country</label>
              <input type="text" class="form-control" formControlName="country">
            </div>
            <div class="form-group-mobile">
              <label>Phone</label>
              <input type="tel" class="form-control" formControlName="locationPhone">
            </div>
            <div class="form-group-mobile">
              <label>Address Type</label>
              <div class="segmented-control" role="group" aria-label="Address type">
                <div class="segmented-option" role="button" tabindex="0"
                     [class.active]="getLocationFormGroup(0)?.get('isPhysical')?.value"
                     (click)="getLocationFormGroup(0)?.get('isPhysical')?.setValue(true)"
                     (keydown.enter)="getLocationFormGroup(0)?.get('isPhysical')?.setValue(true)">
                  <i class="bi bi-geo-alt me-1"></i> Physical
                </div>
                <div class="segmented-option" role="button" tabindex="0"
                     [class.active]="!getLocationFormGroup(0)?.get('isPhysical')?.value"
                     (click)="getLocationFormGroup(0)?.get('isPhysical')?.setValue(false)"
                     (keydown.enter)="getLocationFormGroup(0)?.get('isPhysical')?.setValue(false)">
                  <i class="bi bi-envelope me-1"></i> Postal
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Branches list (Edit only) -->
        <div *ngIf="isEditingSupplier">
          <div class="m-role-group-header mt-3 mb-2">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="mb-1">Branches</h6>
                <small class="text-muted">{{ supplierForm.get('locations')?.value?.length || 0 }} branch(es)</small>
              </div>
              <button type="button" class="btn btn-sm btn-outline-primary" (click)="showLocationForm()">
                <i class="bi bi-plus-lg"></i>
              </button>
            </div>
          </div>

          <!-- Inline location form -->
          <div *ngIf="isEditingLocation" class="mb-3" [@slideInOut]>
            <form [formGroup]="supplierLocationForm" (ngSubmit)="saveSupplierLocation()">
              <div class="form-group-mobile">
                <label>Branch Name</label>
                <input type="text" class="form-control" formControlName="branchName">
              </div>
              <div class="form-group-mobile">
                <label>Address Line 1</label>
                <input type="text" class="form-control" formControlName="addressLine1">
              </div>
              <div class="form-group-mobile">
                <label>City</label>
                <input type="text" class="form-control" formControlName="city">
              </div>
              <div class="form-group-mobile">
                <label>Country</label>
                <input type="text" class="form-control" formControlName="country">
              </div>
              <div class="form-group-mobile">
                <label>Address Type</label>
                <div class="segmented-control" role="group" aria-label="Address type">
                  <div class="segmented-option" role="button" tabindex="0"
                       [class.active]="supplierLocationForm.get('isPhysical')?.value"
                       (click)="supplierLocationForm.get('isPhysical')?.setValue(true)"
                       (keydown.enter)="supplierLocationForm.get('isPhysical')?.setValue(true)">
                    <i class="bi bi-geo-alt me-1"></i> Physical
                  </div>
                  <div class="segmented-option" role="button" tabindex="0"
                       [class.active]="!supplierLocationForm.get('isPhysical')?.value"
                       (click)="supplierLocationForm.get('isPhysical')?.setValue(false)"
                       (keydown.enter)="supplierLocationForm.get('isPhysical')?.setValue(false)">
                    <i class="bi bi-envelope me-1"></i> Postal
                  </div>
                </div>
              </div>
              <div class="d-flex gap-2 mt-2">
                <button type="button" class="btn btn-sm btn-outline-secondary flex-fill" (click)="cancelLocationEdit()">Cancel</button>
                <button type="submit" class="btn btn-sm btn-primary flex-fill">{{ isEditingSupplierLocation ? 'Update' : 'Save' }}</button>
              </div>
            </form>
          </div>

          <!-- Branches summary -->
          <div *ngFor="let loc of supplierForm.get('locations')?.value" class="mdc-card mb-2">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <div class="fw-semibold small">{{ loc.branchName || 'Main' }}</div>
                <div class="text-muted" style="font-size:0.75rem" *ngIf="loc.city">{{ loc.city }}{{ loc.country ? ', ' + loc.country : '' }}</div>
              </div>
              <div class="d-flex align-items-center gap-2">
                <span class="badge loc-type-badge" style="font-size:0.65rem">{{ loc.isPhysical !== false ? 'Physical' : 'Postal' }}</span>
                <span class="badge" [ngClass]="loc.isActive ? 'bg-success' : 'bg-secondary'" style="font-size:0.65rem">{{ loc.isActive ? 'Active' : 'Inactive' }}</span>
                <button type="button" class="btn btn-sm btn-outline-primary py-0 px-1" (click)="editSupplierLocation(loc)" style="font-size:0.75rem">
                  <i class="bi bi-pencil"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="sheet-actions mt-2">
          <button type="button" class="btn btn-outline-secondary flex-fill" (click)="closeSupplierModal()">Cancel</button>
          <button type="submit" class="btn btn-primary flex-fill" [disabled]="supplierForm.invalid">
            {{ isEditingSupplier ? 'Update' : 'Save' }}
          </button>
        </div>

      </form>
    </div>
  </div>
</div>
</div><!-- end d-md-none mobile supplier offcanvas -->

<!-- Mobile Reset Password Bottom-Sheet -->
<div class="d-md-none">
  <div class="modal-overlay" *ngIf="mobileResetPwdVisible || mobileResetIsClosing"
    [style.opacity]="mobileResetIsClosing ? 0 : null"
    [style.transition]="mobileResetIsClosing ? 'opacity 0.28s ease' : null"
    (click)="$event.target === $event.currentTarget && cancelResetPasswordMobile()">
    <div class="modal-sheet" (click)="$event.stopPropagation()"
      [style.transform]="mobileResetIsClosing ? 'translateY(100%)' : (mobileResetSwipeDeltaY > 0 ? 'translateY(' + mobileResetSwipeDeltaY + 'px)' : null)"
      [style.transition]="mobileResetIsClosing ? 'transform 0.3s cubic-bezier(0.4,0,0.2,1)' : (mobileResetSwipeActive ? 'none' : 'transform 0.3s cubic-bezier(0.4,0,0.2,1)')">
      <div class="modal-sheet-handle-bar"
        (touchstart)="onResetSheetTouchStart($event)"
        (touchmove)="onResetSheetTouchMove($event)"
        (touchend)="onResetSheetTouchEnd($event)">
        <div class="modal-sheet-handle"
          [style.width.px]="36 + mobileResetSwipeProgress * 20"
          [style.background]="'rgb(' + Math.round(222 + mobileResetSwipeProgress * -222) + ',' + Math.round(226 + mobileResetSwipeProgress * (122 - 226)) + ',' + Math.round(230 + mobileResetSwipeProgress * (143 - 230)) + ')'">
        </div>
      </div>
      <div class="modal-sheet-body">
        <div class="modal-sheet-icon"><i class="bi bi-key-fill"></i></div>
        <h6 class="modal-sheet-title">Reset Password</h6>
        <p class="modal-sheet-msg">Send a password reset link to <strong>{{ mobileResetPwdUser?.email }}</strong>?</p>
        <div class="modal-sheet-actions">
          <button class="btn btn-secondary flex-fill" (click)="cancelResetPasswordMobile()">Cancel</button>
          <button class="btn btn-warning flex-fill" (click)="confirmResetPasswordMobile()" [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
            Send Reset Link
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
